module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-update update-form container row"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('models.user.edit_user')))]), _vm._v(" "), _c('form', {
    staticClass: "user-update--form col-xs-12 col-sm-12 col-md-6 col-lg-6",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "firstname",
      "label": "models.user.firstname",
      "placeholder": "Andy"
    },
    model: {
      value: (_vm.item.firstname),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstname", $$v)
      },
      expression: "item.firstname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "lastname",
      "label": "models.user.lastname",
      "placeholder": "Kaufman"
    },
    model: {
      value: (_vm.item.lastname),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastname", $$v)
      },
      expression: "item.lastname"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "readonly": true,
      "name": "email",
      "label": "models.user.email",
      "placeholder": "andykaufman@googlemail.com"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.$set(_vm.item, "email", $$v)
      },
      expression: "item.email"
    }
  }), _vm._v(" "), (_vm.item.role == 'admin') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organization.list'),
      expression: "'organization.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "organization",
      "label": "Organization",
      "type": "select",
      "params": {
        'no_i18n': true
      },
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('user-status-select', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('users.update_status'),
      expression: "'users.update_status'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "status",
      "label": "models.user.status"
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.$set(_vm.item, "status", $$v)
      },
      expression: "item.status"
    }
  }), _vm._v(" "), _c('user-role-select', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('users.update_role'),
      expression: "'users.update_role'"
    }],
    attrs: {
      "errors": _vm.errors,
      "name": "roles",
      "label": "models.user.role"
    },
    model: {
      value: (_vm.item.role),
      callback: function($$v) {
        _vm.$set(_vm.item, "role", $$v)
      },
      expression: "item.role"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23b0068a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/UserUpdate.vue
// module id = 1839
// module chunks = 0